/** Links from the finance views into the existing (write) pages and into the 360° view. */
const enc = encodeURIComponent
export const creditPage = (projectId: string, email: string) => `/projects/${enc(projectId)}/admin/users/credit?email=${enc(email)}`
export const subscriptionPage = (projectId: string, email: string) => `/projects/${enc(projectId)}/admin/users/subscriptions?email=${enc(email)}`
export const userPage = (email: string) => `/admin/finance/users?email=${enc(email)}`
